import {
  ActivatedRoute,
  Router
} from "@angular/router";
import { Filtro } from "../filtri/filtri.type";
import { UriHandler } from "../uri-handler/uri-handler.service";
export class SessionHandler {
  FILTER_FIELD: string = "crudfilters";
  CRUD_FIELD: string = "crudSettings";

  KEY_PREFIX: string = "CRUD";

  KEY_FUNCTION_PREFIX = "GA";
  KEY_ID: string = "1";

  PARAM_KEY = "paramId";

  currentRoute: ActivatedRoute;
  private uriHandler: UriHandler;

  constructor(
    //public session: StorageServiceModule,
    private router: Router
  ) {
    this.uriHandler = new UriHandler(this.router);
  }

  setCurrentRoute(functionID: string, active: ActivatedRoute = null) {
    this.currentRoute = active;
    let key_id = "";
    if (active) {
      if (this.uriHandler.has(this.PARAM_KEY, this.currentRoute)) {
        key_id = this.uriHandler.get(this.PARAM_KEY);
      } else {
        key_id = this.makeid();
        this.uriHandler.set(this.PARAM_KEY, key_id);
      }
    }

    this.defineIndexes(functionID, key_id);
  }

  defineIndexes(functionID: string, paramsId: string) {
    this.KEY_FUNCTION_PREFIX = functionID;
    this.KEY_ID = paramsId;
  }

  /**
   * Se impostato parsed non viene calcolato this.getKey()
   * @param id
   * @param parsed
   */
  has(id: string, parsed = false) {
    if (!parsed) {
      id = this.getKey(id);
    }
    let find = false;
    for (let i = 0; i < sessionStorage.length; i++) {
      if (sessionStorage.key(i) == id) {
        find = true;
      }
    }
    return find;
  }

  get(id: string, parsed:boolean=false) {
    if (this.has(id,parsed)) {
      const key=!parsed?this.getKey(id):id;
      return JSON.parse(sessionStorage.getItem(key));
    } else {
      return null;
    }
  }

  set(id: string, values: any, parsed:boolean=false) {
    const stringData = JSON.stringify(values);
    const key=!parsed?this.getKey(id):id;
    sessionStorage.setItem(key, stringData);
  }

  getFiltri(route: ActivatedRoute) {
    return this.get(this.FILTER_FIELD);
  }

  setFiltriQueryParams(filtri: Filtro[], route: ActivatedRoute) {
    this.set(this.FILTER_FIELD, filtri);
  }

  setPageSettings(input:{limit, order, offset}){
    this.set(this.CRUD_FIELD, input);
  }

  getPageSettings(){
    return this.get(this.CRUD_FIELD);
  }

  getCurrentRoute(url) {
    const qp = this.getQueryParams(url);
    return this.router.parseUrl(qp);
  }
  getQueryParams(url: string) {
    const pos = url.indexOf("?");
    if (pos !== -1) {
      return url.substr(pos);
    } else {
      return "";
    }
  }

  getKey(id) {
    return this.KEY_PREFIX + this.KEY_FUNCTION_PREFIX + this.KEY_ID + "_" + id;
  }

  makeid() {
    var text = "";
    var possible =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (var i = 0; i < 5; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
  }
}
